// extracted by mini-css-extract-plugin
module.exports = {"msg-terms-conditions":"PolicyOrTerms_msg-terms-conditions__b7dWO","as-link":"PolicyOrTerms_as-link__1rH5b"};